export const toSentenceCase = (str: string): string => {
	// Check if the string is null or empty
	if (!str) {
		return "";
	}
	// Convert the whole string to lowercase first for consistency
	str = str.toLowerCase();

	// Capitalize the first letter and concatenate it with the rest of the string
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const toTitleCase = (value: string): string => {
	return value
		.replace(/_/g, " ")
		.split(" ")
		.map(w => w.charAt(0).toUpperCase() + w.slice(1))
		.join(" ");
};

/**
 * A value usable as an external link, or null when it is not one.
 *
 * Citations are written by the model, and a missing source comes back as the string
 * "null" or as a bare section number rather than as an absent field. Rendered as an
 * `href` those navigate relative to the current route, which is how "View source" ends
 * up opening an empty page inside the app.
 */
export const toExternalUrl = (value?: string | null): string | null => {
	const trimmed = value?.trim();
	if (!trimmed) return null;
	try {
		const { protocol } = new URL(trimmed);
		return protocol === "http:" || protocol === "https:" ? trimmed : null;
	} catch {
		return null;
	}
};
